import { makeAutoObservable } from "mobx";
import {IXAboutSettings} from "../models/XAbout";
import {IXContacts} from "../models/XContacts";
import {IXProject} from "../models/XProject";

export default class AdminStore {

  footerData: any = {}
  metaData: any = {}
  homeImages: string[] = []
  sliderIndex: number = 0
  sliderInited: boolean = false
  homeSliderSpeed: number = 3000
  interSet: any = null

  translations: any = {}
  transes: any = []
  transActive: boolean = false

  pages: any[] = []
  contacts: IXContacts | null = null

  projects: IXProject[] = []

  dragId: number = 0

  isSettingsInited: boolean = false

  isAboutActive: boolean = true
  aboutLoad: number = 0
  aboutSettings: IXAboutSettings | null = null

  seoConfig: null | any = null
  servicesConfig: null | any = null

  isManagerVisible: boolean = false
  isManagerVisibleOp: boolean = false

  isLogoutVisible: boolean = false 
  lockScreen: boolean = false 
  sidebarToggled: boolean = false
  sidebarTogglex: boolean = false
  mainVisible: boolean = true

  draggingTicket: any | null = null
  draggingTable: any | null = null

  toolbarFixed: boolean = false

  searchText: string = ""

  constructor() {
    makeAutoObservable(this)
  }

  setSearchText(val: string) {
    this.searchText = val
  }

  setToolbarFixed(val: boolean) {
    this.toolbarFixed = val
  }

  setDraggingTable(val: any | null) {
    this.draggingTable = val
  }

  setDraggingTicket(val: any | null) {
    this.draggingTicket = val
  }

  setMainVisible(val: boolean) {
    this.mainVisible = val
  }

  setSidebarToggled(val: boolean) {
    this.sidebarToggled = val
  }

  setSidebarTogglex(val: boolean) {
    this.sidebarTogglex = val
  }

  setLockScreen(val: boolean) {
    this.lockScreen = val
  }

  setIsLogoutVisible(val: boolean) {
    this.isLogoutVisible = val
  }

  setIsManagerVisible(val: boolean) {
    this.isManagerVisible = val
  }

  setIsManagerVisibleOp(val: boolean) {
    this.isManagerVisibleOp = val
  }

  setServicesConfig(val: any | null) {
    this.servicesConfig = val
  }

  setSeoConfig(val: any | null) {
    this.seoConfig = val
  }

  setAboutLoad(val: number) {
    this.aboutLoad = val
  }

  setAboutSettings(val: IXAboutSettings) {
    this.aboutSettings = val
  }

  setIsAboutActive(val: boolean) {
    this.isAboutActive = val
  }

  setTransActive(val: boolean) {
    this.transActive = val
  }

  setIsSettingsInited(val: boolean) {
    this.isSettingsInited = val
  }

  setFooterData(val: any) {
    this.footerData = val
  }

  setTranses(val: any) {
    this.transes = val
  }

  setTranslations(val: any) {
    this.translations = val
  }

  setInterSet(index: any) {
    this.interSet = index
  }

  setHomeSliderSpeed(index: number) {
    this.homeSliderSpeed = index
  }

  setSliderInited(index: boolean) {
    this.sliderInited = index
  }

  setSliderIndex(index: number) {
    this.sliderIndex = index
  }

  setProjects(val: IXProject[]) {
    this.projects = val
  }

  setDragId(id: number) {
    this.dragId = id
  }

  setContacts(val: IXContacts | null) {
    this.contacts = val
  }

  setHomeImages(val: string[]) {
    this.homeImages = val
  }

  setMetaData(val: any) {
    this.metaData = val
  }

  setPages(val: any[]) {
    this.pages = val
  }

}